import { createAction } from 'redux-actions';
import {
    EXPORT_WATCH_LIST_ALL_ENTRIES_CSV,
    CLEAR_EXPORT_WATCH_LIST_ALL_ENTRIES_CSV,
} from '../types';

import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
    exportWatchListAllEntriesCsv,
    exportWatchListAllEntriesCsvPending,
    exportWatchListAllEntriesCsvFulfilled,
    exportWatchListAllEntriesCsvRejected,
} = createAsyncActions(EXPORT_WATCH_LIST_ALL_ENTRIES_CSV, 'exportWatchListAllEntriesCsv');

export const clearWatchListEntriesCsv = createAction(CLEAR_EXPORT_WATCH_LIST_ALL_ENTRIES_CSV);



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/actions/exportWatchListAllEntriesCsvAction.js